var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_2562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 4.00049C7.5821 4.00049 4 7.58209 4 11.9995C4 15.2759 5.96953 18.0899 8.78892 19.3271C8.76506 18.768 8.7837 18.0982 8.9269 17.4906C9.08155 16.8408 9.95737 13.1308 9.95737 13.1308C9.95737 13.1308 9.70209 12.62 9.70209 11.8656C9.70209 10.6798 10.389 9.79462 11.244 9.79462C11.9725 9.79462 12.3233 10.3415 12.3233 10.9955C12.3233 11.7265 11.8574 12.8213 11.6176 13.8343C11.4174 14.6831 12.0431 15.3755 12.8794 15.3755C14.3955 15.3755 15.4166 13.428 15.4166 11.1221C15.4166 9.36917 14.2357 8.05676 12.0877 8.05676C9.66055 8.05676 8.14968 9.86622 8.14968 11.8873C8.14968 12.5847 8.35413 13.0758 8.67684 13.4561C8.82424 13.6314 8.84498 13.702 8.79102 13.9023C8.75261 14.0496 8.66543 14.404 8.62808 14.5441C8.57509 14.747 8.41118 14.8191 8.22753 14.7449C7.10998 14.2877 6.59007 13.0648 6.59007 11.6887C6.59007 9.41584 8.50668 6.69142 12.3067 6.69142C15.3615 6.69142 17.3726 8.90092 17.3726 11.2735C17.3726 14.4117 15.6272 16.7567 13.0548 16.7567C12.1915 16.7567 11.379 16.2892 11.1008 15.7589C11.1008 15.7589 10.636 17.6026 10.5385 17.958C10.3683 18.5744 10.0362 19.1916 9.73318 19.672C10.4523 19.8842 11.2129 19.9999 12.0006 19.9999C16.419 19.9999 20 16.4184 20 11.9994C20 7.58209 16.419 4.00049 12.0006 4.00049Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_2562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.fe5b4cad20b3534243b8b2d4ee26d525.svg";
export { ForwardRef as ReactComponent };